export enum ChecklistTemplateVersionEntryRangeType {
  PREDEFINED = 'PREDEFINED',
  CONDITION = 'CONDITION'
}
